import React from "react";
import BreadCrumb from "Common/BreadCrumb";
import WelcomeWidget from "./WelcomeWidget";
import Widgets from "./Widgets";
import { withTranslation } from "react-i18next";

const CustomerDashboard = (props: any) => {
  return (
    <React.Fragment>
      <BreadCrumb
        title={props.t("CustomerDashboard")}
        pageTitle={props.t("CustomerDashboard")}
      />
      <div className="grid grid-cols-12 gap-x-5">
        <WelcomeWidget />
        <Widgets />
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(CustomerDashboard);
